import moment from "moment";

export function StatusIndicator({ ultimo_registro }) {

  if (!ultimo_registro) return (
    <div className="size-[9px] bg-red-500 rounded-full" />
  )

  const data = moment(ultimo_registro);
  const hoje = moment().startOf("day");

  const isAnterior = data.isBefore(hoje);

  return isAnterior ? (
    <div className="size-[9px] bg-red-500 rounded-full" />
  ) : (
    <div className="size-[9px] bg-[#21ba45] rounded-full animate-pulse" />
  );
};